// extracted by mini-css-extract-plugin
export var container = "_pm-0";
export var dotAnimation = "_pm-2";
export var dotsLoading = "_pm-1";